<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage" id="_idContainer000">
<p class="pl-author">Noelle Marchand<br/>and<br/>Jan Drexler</p>
<p class="pl-title"><a id="_idTextAnchor000"></a>The Texan’s<br/>Inherited Family<br/>&amp;<br/>A Home for His Family</p>
<p class="pl-logo"><span class="bold"><img alt="logo" height="70" src="image/LI_2020.png"/></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_Page.vue?617be9ca